module.exports = __webpack_public_path__ + "img/main_96.389b24d4.jpg";